import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { PropsCompanyMap } from "../../types/interfaces";
import { useTranslation } from "react-i18next";

const customIcon = L.icon({
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const CompanyMap: React.FC<PropsCompanyMap> = ({ companies }) => {
  const { t } = useTranslation();
  const defaultMapCenter: [number, number] = [40.416775, -3.70379]; // Madrid
  let mapCenter = defaultMapCenter;

  if (companies.length > 0) {
    const firstComp = companies[0];
    if (firstComp.lat && firstComp.long) {
      mapCenter = [firstComp.lat, firstComp.long];
    }
  }

  return (
    <div className="h-[500px] w-full mb-8 border border-black rounded">
      <MapContainer center={mapCenter} zoom={6} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {companies.map((comp, idx) => {
          if (comp.lat && comp.long) {
            return (
              <Marker key={idx} position={[comp.lat, comp.long]} icon={customIcon}>
                <Popup>
                  <div className="text-center">
                    <strong>{comp.name}</strong>
                    <br />
                    {comp.primary_domain || t("company_map.no_domain")}
                    <br />
                    <em>{t("company_map.similarity", { similarity: comp.similarity })}</em>
                  </div>
                </Popup>
              </Marker>
            );
          }
          return null;
        })}
      </MapContainer>
    </div>
  );
};

export default CompanyMap;
